<template>
  <div class="container">
    <div class="report-label">
      <p>巡查汇总条形图</p>
    </div>
    <div class="histogram">
      <div class="histogram-param-input-bar">
        <div class="condition">
          <span>图表：</span>
          <a-select
            v-model="chooseChartType"
            @change="handleChartType"
            
          >
            <a-select-option v-for="item in chartTypeDict" :key="item.title"  :value="item.title" >{{item.title}}</a-select-option>
          </a-select>
        </div>
        <div class="condition">
          <span>时间区间：</span>
          <a-range-picker @change="onChange" />
        </div>
        <div class="condition">
          <span>请选择基地：</span>
          <a-select style="width: 120px" @change="handleChange" :value="chooseBaseName">
            <a-select-option :value="item" v-for="(item, index) in userBaseList" :key="index">
              {{ item }}
            </a-select-option>
          </a-select>
        </div>
        <div class="condition">
          <span>筛选部门：</span>
          <a-select
            :value="chooseDepartName"
            style="width: 200px"
            @change="handleChangeWorkshop"
            notFoundContent="暂无数据"
          >
            <a-select-option  v-for="(item) in userDepartList" :value="item.value" :key="item.text">
              {{ item.text }}
            </a-select-option>
          </a-select>
        </div>
        <div class="condition">
          <span>巡查类型：</span>
          <a-select style="width: 200px" placeholder="请选择巡查类型" v-model="inspectionType"  @change="handleInspectionType" >
              <a-select-option  value=""  key="all" >全部</a-select-option>
              <a-select-option  value="inspection"  key="inspection" >常规巡查</a-select-option>
              <a-select-option  value="safety"  key="safety" >安全巡查</a-select-option>
              <a-select-option  value="action"  key="action" >行为督查</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="error-rate-style"  v-show="chooseChartType=='异常率'"  >
        <div class="chart-title">
          <p>异常率条形图</p>
        </div>
        <v-chart :height="height2" :data="data2" :padding="padding" :width="1200" :scale="scale2">
          <v-coord type="rect" direction="LB" />
          <v-tooltip />
          <v-axis dataKey="name" :label="label" />
          <v-interval position="name*rate" :label="labelInterval" :color="color2" />
        </v-chart>
      </div>
      <div class="fix-rate-style"  v-show="chooseChartType=='改善率'"  >
        <div class="chart-title">
          <p>改善率条形图</p>
        </div>
        <v-chart :height="height" :data="data" :padding="padding" :width="1200" :scale="scale">
          <v-coord type="rect" direction="LB" />
          <v-tooltip />
          <v-axis dataKey="name" :label="label" />
          <v-interval position="name*rate" :label="labelInterval" :color="color1" />
        </v-chart>
      </div>
    </div>
  </div>
</template>

<script>
import { countImproveRatePC, countQuestionRate, findRoleAndBase, findDepartByUserNo } from '@/api/api'
const DataSet = require('@antv/data-set')

const color1 = [
  'rate',
  function (val) {
    if (val <= 50) {
      //红色
      return '#ff4d4f'
    } else if (val > 50 && val <= 70) {
      //橙色
      return '#FF8C00'
    } else if (val > 70 && val < 90) {
      //蓝色
      return '#2194ff'
    } else {
      //绿色
      return '#90EE90'
    }
  },
]
const color2 = [
  'rate',
  function (val) {
    if (val <= 20) {
      //绿色
      return '#90EE90'
    } else if (val > 20 && val <= 40) {
      //蓝色
      return '#2194ff'
    } else if (val > 40 && val < 60) {
      //橙色
      return '#FF8C00'
    } else {
      //红色
      return '#ff4d4f'
    }
  },
]
const scale = [
  {
    dataKey: 'rate',
    nice: false,
    alias: '完成率(%)',
  },
]

const scale2 = [
  {
    dataKey: 'rate',
    nice: false,
    alias: '异常率(%)',
  },
]

const label = { offset: 12 }

const labelInterval = [
  'rate',
  {
    useHtml: true,
    htmlTemplate: function htmlTemplate(text, item) {
      var a = item.point
      return '<span class="g2-label-item"><p class="g2-label-item-value" >' + a.rate + '</p></div>'
    },
  },
]

export default {
  data() {
    return {
      data: [],
      data2: [],
      height: 400,
      height2: 400,
      label: label,
      color1,
      color2,
      scale2,
      scale,
      labelInterval,
      chooseBaseName: '',
      chooseDepartName: '',
      startDate: '',
      endData: '',
      userIsAdmin: false,
      userIsWorker: false,
      userIsInspection: false,
      userBaseList: [],
      userDepartList: [{
        text:"全部",
        value:"",
      }],
      padding: { top: 20, right: 100, bottom: 20, left: 150 },
      chooseChartType:"异常率",
      inspectionType:"",
      chartTypeDict:[{
        title:"异常率",
      },{
        title:"改善率",
      }]
    }
  },
  mounted() {
    this.getUserRole()
  },
  methods: {
    handleChartType(data){

    },
    handleInspectionType(){
      this.getData()
    },
    onChange(date, dateString) {
      this.startDate = dateString[0]
      this.endData = dateString[1]
      this.getData() 
    },
    handleChangeWorkshop(value) {
      this.chooseDepartName = value
      this.getData()
    },
    handleChange(value) {
      this.chooseBaseName = value
      this.getUserDepart()
    },
    getUserRole() {
      findRoleAndBase(this.$ls.get('Login_Userinfo').username).then((res) => {
        if (res.success) {
          this.userBaseList = res.result.baseList
          this.userIsAdmin = res.result.hasAdmin
          this.userIsWorker = res.result.hasWorker
          this.userIsInspection = res.result.hasInspection
          if (this.userBaseList.length == 1) {
            this.chooseBaseName = this.userBaseList[0]
            this.getUserDepart()
          } else if (this.userBaseList.length > 1) {
            this.chooseBaseName = '厦门基地'
            this.getUserDepart()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getUserDepart() {
      let queryParam = {
        base: this.chooseBaseName,
        hasAdmin: this.userIsAdmin,
        userNo: this.$ls.get('Login_Userinfo').username,
      }
      findDepartByUserNo(queryParam).then((res) => {
        if (res.success) {
          this.userDepartList = res.result.map((item)=>{
            return {
              text:item,
              value:item
            }
          })
          this.userDepartList.unshift({
              text:"全部",
              value:""
            })
          if (this.userDepartList.length > 0) {
            this.chooseDepartName = this.userDepartList[0].value
          } else {
            this.chooseDepartName = ''
          }
          this.getData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getData() {
      let queryParam = {
        base: this.chooseBaseName,
        depart: this.chooseDepartName,
        endDate: this.endData,
        startDate: this.startDate,
        hasAdmin: this.userIsAdmin,
        hasInspection: this.userIsInspection,
        hasWorker: this.userIsWorker,
        inspectionType:this.inspectionType
      }
      countImproveRatePC(queryParam).then((res) => {
        if (res.success) {
          let sourceDate = res.result
          let hNum = res.result.length / 4
          if (hNum < 1) {
            hNum = 1
          }
          this.height = hNum * 200
          const dv = new DataSet.View().source(sourceDate)
          dv.transform({
            type: 'sort',
            callback(a, b) {
              return a.rate - b.rate > 0
            },
          })
          this.data = dv.rows
        } else {
          this.$message.error(res.message)
        }
      })
      countQuestionRate(queryParam).then((res) => {
        if (res.success) {
          let sourceDate = res.result
          let hNum = res.result.length / 4
          if (hNum < 1) {
            hNum = 1
          }
          this.height2 = hNum * 200
          const dv = new DataSet.View().source(sourceDate)
          dv.transform({
            type: 'sort',
            callback(a, b) {
              return a.rate - b.rate > 0
            },
          })
          this.data2 = dv.rows
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style scoped>
.container {
  background: #ffffff;
  padding-bottom: 50px;
}
.report-label {
  font-size: 18px;
  font-weight: 550;
  padding-top: 10px;
  text-align: center;
}
.pie-chart {
  background: #ffffff;
  height: 400px;
}
.histogram {
  background: #ffffff;
}
.histogram-param-input-bar {
  height: 100px;
  padding-left: 30px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.condition {
  margin-left: 10px;
}
.chart-title {
  text-align: center;
  font-size: 18 px;
  font-weight: 550;
}
/deep/.ant-select-dropdown-menu-item{
  min-height: 30px !important;
}
</style>
